// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__luukv","filesListContainer":"PosDisputesFiles_filesListContainer__2m8jA","filesButton":"PosDisputesFiles_filesButton__3bdLK"};